/**
 * Returns `true` if `x` is greater than `y`.
 *
 * @param {number|string} x
 * @param {number|string} y
 * @returns {boolean}
 */
export function gt(x, y) {
  return Number(x) > Number(y);
}
